import { ApplicationDefinitionsService } from '../services';
import { action, observable, runInAction, computed, makeObservable } from 'mobx';
import { ApplicationDefinition } from '../services/types';

export default class ApplicationDefinitionsStore {
    projectApplications: ApplicationDefinition[] = [];

    applicationNamesDictionary: { [id: string]: ApplicationDefinition } = {};

    loading: boolean = false;

    get hasApps() {
        return !!this.projectApplications && !!this.projectApplications.length;
    }

    constructor(public service: ApplicationDefinitionsService) {
        makeObservable(this, {
            projectApplications: observable,
            applicationNamesDictionary: observable,
            loading: observable,
            hasApps: computed,
            loadApplicationsForProject: action.bound
        });
    }

    clearApplications() {
        runInAction(() => {
            this.projectApplications = [];
        });
    }

    async loadApplicationsForProject(projectId: string) {
        if (!projectId) {
            return this.clearApplications();
        }

        runInAction(() => {
            this.loading = true;
        });
        const appRes = await this.service.getApplicationDefinitionsForProject(projectId, 'Published');
        runInAction(() => {
            this.projectApplications = appRes;
            this.loading = false;

            this.projectApplications
                .filter(a => a.state === 'Published')
                .forEach(a => {
                    this.applicationNamesDictionary[a.id] = a;
                });
        });
    }
}
